import React from 'react';

import { Heartbeat as HeartbeatUI } from '@/components/ui/dashboard/Monitor';
import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';

const Heartbeat = ({ data: robotId }) => {
  const heartbeat = useRobotTelemetry(robotId, MESSAGE.HEARTBEAT);

  return <HeartbeatUI heartbeat={heartbeat} />;
};

export default Heartbeat;
